<script setup>
import { ref } from 'vue';
import { useMainStore } from '../../../../stores/index';
import ModalBase from './ModalOverlay.vue';

const Store = useMainStore();
const viewDocument = ref(null);

const responsableTask = ref(Store.user);
const responsableTaskEdit = ref([]);
const edit = ref(false);

const openModal = () => {
  edit.value = false;
  if (viewDocument.value) viewDocument.value.openModal();
};

const openModalEdit = () => {
  edit.value = true;
  responsableTaskEdit.value = Store.EditresponsableTask;
  if (viewDocument.value) viewDocument.value.openModal();
};

const ChangeResponsable = () => {
  Store.responsableTask = responsableTask.value;
  if (viewDocument.value) viewDocument.value.closeModal();
};

const EditChangeResponsable = () => {
  Store.EditresponsableTask = responsableTaskEdit.value;
  if (viewDocument.value) viewDocument.value.closeModal();
};

defineExpose({
  openModal,
  openModalEdit
});
</script>

<template>
  <div>
    <ModalBase ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="m-0 font-docs font-weight-bold" style="font-size: 18px; color: #212529;">
            Editar responsável pela tarefa
          </h5>
          <button
            id="close"
            type="button"
            class="close"
            @click="viewDocument.closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <template #body>
        <div class="font-docs">
          <label class="label-custom mb-2">Selecione o responsável</label>

          <div v-if="!edit">
            <Dropdown
              v-model="responsableTask"
              :options="Store.users"
              filter
              optionLabel="name"
              placeholder="Busque por nome ou e-mail..."
              class="w-100 custom-dropdown"
            >
              <template #value="slotProps">
                <div class="d-flex align-items-center" v-if="slotProps.value">
                  <img :alt="slotProps.value.name" :src="$userAvatar(slotProps.value.path_image)" class="mr-2" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;" />
                  <div class="d-flex flex-column">
                    <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.value.name }}</span>
                    <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.value.email }}</span>
                  </div>
                </div>
              </template>
              <template #option="slotProps">
                <div class="d-flex align-items-center py-1">
                  <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;" />
                  <div class="d-flex flex-column">
                    <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.option.name }}</span>
                    <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.option.email }}</span>
                  </div>
                </div>
              </template>
            </Dropdown>
          </div>

          <div v-if="edit">
            <Dropdown
              v-model="responsableTaskEdit"
              :options="Store.users"
              filter
              optionLabel="name"
              placeholder="Busque por nome ou e-mail..."
              class="w-100 custom-dropdown"
            >
              <template #value="slotProps">
                <div class="d-flex align-items-center" v-if="slotProps.value">
                  <img :alt="slotProps.value.name" :src="$userAvatar(slotProps.value.path_image)" class="mr-2" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;" />
                  <div class="d-flex flex-column">
                    <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.value.name }}</span>
                    <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.value.email }}</span>
                  </div>
                </div>
              </template>
              <template #option="slotProps">
                <div class="d-flex align-items-center py-1">
                  <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;" />
                  <div class="d-flex flex-column">
                    <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.option.name }}</span>
                    <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.option.email }}</span>
                  </div>
                </div>
              </template>
            </Dropdown>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-action font-docs" @click="viewDocument.closeModal()">
            Cancelar
          </button>
          <button v-if="!edit" type="button" class="btn btn-solid-action font-docs" @click="ChangeResponsable">
            Salvar
          </button>
          <button v-if="edit" type="button" class="btn btn-solid-action font-docs" @click="EditChangeResponsable">
            Salvar
          </button>
        </div>
      </template>
    </ModalBase>
  </div>
</template>

<style scoped>
.font-docs {
  font-family: inherit;
}

.label-custom {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: block;
}

.btn-outline-action {
  color: #F1860B;
  border: 1px solid #F1860B;
  background: transparent;
  font-weight: 600;
  padding: 6px 18px;
  border-radius: 6px;
}

.btn-solid-action {
  background-color: #F1860B;
  color: #ffffff;
  border: 1px solid #F1860B;
  font-weight: 600;
  padding: 6px 20px;
  border-radius: 6px;
}

:deep(.custom-dropdown.p-dropdown) {
  height: 40px !important;
  border-radius: 6px !important;
  border-color: #ced4da !important;
  align-items: center;
}
</style>